<div class="bp-modal">
	<bp-modal-header header class="large-weight" [title]="'add_wallet' | translate">
		<a right (click)="close()" (keydown.enter)="close()" [tabIndex]="0">{{ "close" | translate }}</a>
	</bp-modal-header>
	<div class="bp-modal-body">
		<div class="bp-modal-body-section pb-25">
			<div class="pr-70 pl-70">
				<div class="text-center mb-35 mr-25 ml-25">
					{{ "small_text_information_about_new_wallet" | translate }}
				</div>
				<div class="form-group">
					<label for="select">{{ "coin_name_label" | translate }}</label>
					<bp-select
						id="select"
						class="wallet-modal-select mb-5"
						[options]="tradableOptions"
						[(selectedValue)]="tradable"
						[searchTermOnClose]="tradable.getName()"
						(selectedValueChange)="updatePrefillName()"
						[bindLabel]="'name'"
						[searchable]="true">
					</bp-select>
				</div>
				<bp-input
					type="text"
					[placeholder]="'name' | translate"
					[label]="'add_wallet_name' | translate"
					(valueChange)="updateOnEmpty($event)"
					[(model)]="data"
					field="name"
					[error]="data.getValidationError('name') | translate"></bp-input>
			</div>
			<div class="mt-40">
				<loading-button
					styles="price-alert-button btn btn-primary btn-block btn-lg"
					[text]="'create_new_wallet' | translate"
					[disabled]="operationInProgress"
					(onClick)="save()">
				</loading-button>
			</div>
		</div>
	</div>
</div>
